import { Component, Input, OnInit, inject, DestroyRef, OnChanges, SimpleChanges, ViewChild, effect } from '@angular/core';
import { ActionService } from 'src/app/shared/services/action/action.service';
import { ActivatedRoute } from '@angular/router';
import { GlobalFilterService } from 'src/app/shared/services/filters/global-filter.service';
import * as _ from 'lodash'
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ScoreWidgetComponent } from '../../../../shared/components/score/score-widget/score-widget.component';
import { NgIf } from '@angular/common';
import { LtmsBarChartViewComponent } from '../../../../shared/components/graph/ltms-bar-chart-view/ltms-bar-chart-view.component';
import { LtmsErrorComponent } from '../../../../shared/components/ltms-error/ltms-error.component';
import { LtmsLoaderComponent } from '../../../../shared/components/ltms-loader/ltms-loader.component';
@Component({
    selector: 'app-action-ageing-actionable-issue-bar-chart',
    templateUrl: './action-ageing-actionable-issue-bar-chart.component.html',
    styleUrls: ['./action-ageing-actionable-issue-bar-chart.component.scss'],
    imports: [ScoreWidgetComponent, NgIf, LtmsBarChartViewComponent, LtmsErrorComponent, LtmsLoaderComponent]
})
export class ActionAgeingActionableIssueBarChartComponent implements OnInit, OnChanges {
  title: string = '';
  lowerChartDiscription: string = 'Stacked bar chart trending the count of open cases, segmented by whether their current age is within or has missed the target TAT.';
  @Input() componentId: string = ""
  @Input() filters: any = [];
  @ViewChild(ScoreWidgetComponent) scoreWidgetComponent!: ScoreWidgetComponent;
  destroyRef = inject(DestroyRef);
  chartId: string = "ltms-bar-chart-" + this.getTimeStamp()
  chartStaticId: string = 'ltms-age-category-chart'
  widgetConfig: any = {
    "elementId": "ltms-widget-" + this.getTimeStamp(),
    "trendSelector": true,
    "viewSelector": {
      enable: true,
      type: 'chart'
    },
    "download": {
      enable: true,
      componentId: this.chartStaticId,
      data: {        
        "fileName": '',
        "title": '',
        "columns": [],
        "rows": []
      }
    },
    "fullscreen": {
      enable: true,
      componentId: this.componentId
    }
  }
  xAxis: any = {
    "title": {
      "padding": 0,
      "display": true,
      "text": "",
      "font": {
        "family": "Asap",
      },
      "color": "#7f7f7f"
    },
  }
  yAxis: any = {
    "title": {
      "padding": 0,
      "display": true,
      "text": "",
      "font": {
        "family": "Asap",
      },
      "color": "#7f7f7f"
    }
  }
  dateFilterField = _.get(Helpers, 'datePicker.dateFilterType', 1) == 1 ? "feedback_request_date" : "created_date";
  isDataLoaded: boolean = false;
  errorCode: string = '404';
  isDataAvailable: boolean = false;
  scoreTrendDataAvailable: boolean = false;
  activeTabLabel: string = "- Average Age (Hours)"
  brandId: string = '';
  isRequestDate: any = '';
  fromDate: string = '';
  toDate: string = '';
  date_filter_type: number = 1;
  // date_filter_field: string = "created_date";
  brandDetails: any = {}
  universalFilter: any = {};
  accountDetails: any = {}
  isFullScreen: boolean = false;
  exportsData: any = [];
  downloadReportHeader: any = [];
  hierarchStack: any = [];
  chartData: any = {
    chartId: this.chartStaticId,
    xAxis: {},
    yAxis: {},
    chart: {
      title: '',
      description: '',
      trendType: 'Monthly',
      xValues: [],
      hiddenValues: [],
      yValues: [],
      gradientColors: ["#301A4B", "#301A4B0F"],
      borderColor: '#301A4B',
      pointBorderColor: 'white',
      pointBackgroundColor: '#301A4B',
      pointHoverBackgroundColor: '#301A4B'
    },
    enable_click: true
  }

  dataSource: any = {}
  selectedTrendType: any = {};
  showPercentage: boolean = false;

  scoreWidget(type: string): any {
    return {
      isFullScreenButtonShow: true,
      isDownloadButtonShow: true,
      isTrendDropdownShow: true,
      isAbsoluteChartShow: true,
      isPercenttageChartShow: true
    };
  }

  constructor(
    public _actionService: ActionService,
    private route: ActivatedRoute,
    private _analytics: ResponseAnalyticsService,
    private globalFilterService: GlobalFilterService,
    private _helpers: HelpersService,
    private _appStateService: AppStateService
  ) {
      effect(()=>{
        if (this._appStateService.initialized()) {
          this.universalFilter = this._appStateService.universalFilter()
          this.hierarchStack = this._appStateService.hierarchyStack();
          const datePicker:any = this._appStateService.datePicker()
          this.isRequestDate = datePicker.isRequestDate
          this.getTrendsData(this.selectedTrendType);
        }
      })
      // Add event listeners for Escape key and click outside
      document.addEventListener('keydown', this.handleKeyDown.bind(this));
      document.addEventListener('click', this.handleClickOutside.bind(this));
    }

  ngOnInit(): void {
    this.widgetConfig = {
      "elementId": "ltms-widget-" + this.getTimeStamp(),
      "trendSelector": true,
      "viewSelector": {
        enable: true,
        type: 'chart'
      },
      "download": {
        enable: true,
        componentId: this.chartStaticId,
        data: {
          "fileName": '',
          "title": '',
          "columns": [],
          "rows": []
        }
      },
      "fullscreen": {
        enable: true,
        componentId: this.componentId
      },
    }
    this.route.queryParams.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(params => {
      this.brandId = params['project_id'];
    });

    this._helpers.appState.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((state: any) => {
      if (state && !state.pending) {
        this.widgetConfig.elementId = "ltms-widget-" + this.getTimeStamp()
        this.title = (state.hierarchyStack && state.hierarchyStack.length) ? 'TAT Status Distribution - Trend - ' + state.hierarchyStack[0].group_key[0] : 'TAT Status Distribution - Trend - ' + state.brandDetails.name;
        this.fromDate = state.datePicker['startDate'];
        this.toDate = state.datePicker['endDate'];
        this.universalFilter = state.universalFilter ? state.universalFilter : {};
        this.brandDetails = state.brandDetails
        this.accountDetails = state.accountDetails
        this.hierarchStack = state.hierarchyStack;
        this.date_filter_type = state.datePicker['dateFilterType'];
        this.isRequestDate = state.datePicker.isRequestDate
        // this.onTrendTypeChange(this.selectedTrendType)
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filters'] && !_.isEmpty(this.filters) && _.has(this.filters, 'filters')) {
      this.onTrendTypeChange(this.selectedTrendType)
    }
  }

  onFullScreen (event: any) {
    this.isFullScreen = event;
  }

  // Method to handle Escape key press
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.isFullScreen) {
      this.scoreWidgetComponent.onFullscreen(); // Call the onFullscreen method from ScoreWidgetComponent
    }
  }

  // Method to handle clicks outside the content
  handleClickOutside(event: MouseEvent) {
    const overlayElements = document.getElementsByClassName('fullscreen'); // Get all elements with the overlay class
    const contentElements = document.getElementsByClassName('ageing-bar-chart-component'); // Get all elements with the content class

    // Check if the clicked element is the overlay
    const isOverlayClick = Array.from(overlayElements).some(overlay => overlay.contains(event.target as Node));
    const isContentClick = Array.from(contentElements).some(content => content.contains(event.target as Node));

    if (this.isFullScreen && isOverlayClick && !isContentClick) { // Only exit fullscreen if the overlay is clicked
      this.scoreWidgetComponent.onFullscreen(); // Call the onFullscreen method from ScoreWidgetComponent
    }
  }

  ngOnDestroy(): void {
    // Remove event listeners and reset
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }

  getTimeStamp() {
    return new Date().getTime()
  }

  onTrendTypeChange(trendType: any) {
    this.selectedTrendType = trendType
    this.getTrendsData(trendType)
    if (!_.isEmpty(this.filters) && !_.isEmpty(this.filters.filters) && this.filters.groupKeyAlias) {
      _.each(this.filters.filters, (filter) => {
        if (filter && filter.field_id == this.filters.groupKeyAlias) {
          this.title = 'TAT Status Distribution - Trend - ' + filter.field_value
        } else {
          this.title = (this.hierarchStack && this.hierarchStack.length) ? 'TAT Status Distribution - Trend - ' + this.hierarchStack[0].group_key[0] : 'TAT Status Distribution - Trend - ' + this.brandDetails.name;
        }
      })
    } else {
      this.title = (this.hierarchStack && this.hierarchStack.length) ? 'TAT Status Distribution - Trend - ' + this.hierarchStack[0].group_key[0] : 'TAT Status Distribution - Trend - ' + this.brandDetails.name;
    }
    this.widgetConfig['download']['data']['fileName'] = "Action Trend - Ageing" + " " + trendType.name
    this.widgetConfig['download']['data']['title'] = "Action Trend - Ageing" + " - " + trendType.name
  }

  onViewChange(event: any) {
    this.showPercentage = event
    if (this.showPercentage) {
      this.chartData.yAxis.title.text = "Percentage of Cases";
      this.chartData.chart.hiddenValues = [{
        label: "Avg.. (hrs)",
        data: this.dataSource.age
      }]
      this.chartData.chart.yValues = [{
        label: "Within TAT",
        borderColor: "#136B8D",
        backgroundColor: '#136B8D',
        data: this.dataSource.percent.within_tat
      }, {
        label: "Missed TAT",
        borderColor: "#F3B34D",
        backgroundColor: '#F3B34D',
        data: this.dataSource.percent.outside_tat
      }]
    } else {
      this.chartData.yAxis.title.text = "Count of Cases";
      this.chartData.chart.hiddenValues = [{
        label: "Avg.. (hrs)",
        data: this.dataSource.age
      }]
      this.chartData.chart.yValues = [{
        label: "Within TAT",
        borderColor: "#136B8D",
        backgroundColor: '#136B8D',
        data: this.dataSource.within_tat
      }, {
        label: "Missed TAT",
        borderColor: "#F3B34D",
        backgroundColor: '#F3B34D',
        data: this.dataSource.outside_tat
      }]
    }
    this.chartId = "ltms-bar-chart-" + this.getTimeStamp()
  }

  getTrendsData(trendType?: any) {
    this.isDataLoaded = false;
    let params = this._actionService.getTrendsRequestParams({
      dateFilterField: this.isRequestDate ? "feedback_request_date" : "created_date",
      projectId: this.brandId,
      trendType: trendType.trend_type,
      action_type: "ageing",
      appliedfilters: _.get(this.filters, 'filters', [])
    })

    // let payload = this.getTrendsRequestParams()
    // TODO: for now picking the date range from globalFilterService, this will be removed once RESOLVED helpers method
    params.from = this.fromDate;
    params.to = this.toDate;
    params.brand_id = this.brandId;
    params.group_key_alias = _.get(this.filters, 'groupKeyAlias', 'brands');
    params.universal_filter = this.universalFilter;
    params.actionable_filter = _.get(this.brandDetails, "action_management_configuration.actionables", {});
    params.age_type = _.get(this.brandDetails, "action_management_configuration.ageing_config.type", 1);
    params.turnaround = _.get(this.brandDetails, "action_management_configuration.ageing_config.turnaround_time", 0);

    this._actionService.getTrendsData(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: (response) => {
        if (_.hasIn(response.data, 'response') && !_.isEmpty(response.data.response)) {
          let trendData = _.get(response, 'data.response', [])
          trendData = _.map(trendData, (data: any) => {
            if (data) {
              data.total_count = data.outside_tat + data.within_tat
            }
            return data;
          })
          this.dataSource = this._actionService.processTrendsData(trendData);
          const fieldsToExport = this.getExportsFields(trendType.name)
          // TODO: Need to uncomment next line to export data
          this.exportsData = this._actionService.prepareDataForExport(trendData, fieldsToExport)
          fieldsToExport.push({
            header: "Missed TAT %",
            dataKey: "percent.outside_tat",
            type: "number",
            order: "5",
            defaultValue: 0,
            display_format: ""
          },{
            header: "Within TAT %",
            dataKey: "percent.within_tat",
            type: "number",
            order: "6",
            defaultValue: 0,
            display_format: ""
          })
          this.widgetConfig.download.data.columns = fieldsToExport;
          this.downloadReportHeader = fieldsToExport
          this.chartData.chart.tooltipFields = fieldsToExport
          this.chartData.chart.tooltipData = this.exportsData
          this.chartData.chart.xValues = this.dataSource.timestamp
          this.chartData.xAxis = this.xAxis;
          this.chartData.yAxis = this.yAxis;
          this.chartData.xAxis.title.text = this.isRequestDate ? "Request Date" : "Response Date";
          this.chartData.yAxis.title.text = "Count of Cases";
          this.chartData.chart.trendType = trendType.name
          this.chartData.chart.hiddenValues = [{
            label: "Avg.. (hrs)",
            data: this.dataSource.age
          }]
          this.chartData.chart.yValues = [{
            label: "Within TAT",
            borderColor: "#136B8D",
            backgroundColor: '#136B8D',
            data: this.dataSource.within_tat
          }, {
            label: "Missed TAT",
            borderColor: "#F3B34D",
            backgroundColor: '#F3B34D',
            data: this.dataSource.outside_tat
          }]
          // TODO: need to uncomment next line for data download
          this.widgetConfig.download.data.rows = this.exportsData;
          // this.widgetConfig.elementId="ltms-widget-" + this.getTimeStamp()
          this.chartId = "ltms-bar-chart-" + this.getTimeStamp()
          this.isDataAvailable = true;
          this.isDataLoaded = true;
        }
        else {
          this.isDataAvailable = false;
          this.isDataLoaded = true;
        }
      },
      error: (err) => {
        this.isDataAvailable = false;
        this.isDataLoaded = true;
        if (err.status == '500') {
          this.errorCode = '500'
        } else if (err.status == "404") {
          this.errorCode = '404'
        } else if (err.status == "408") {
          this.errorCode = '408'
        }
      }
    })
  }

  onDownload() {
    let downloadConfig: any = {
      dataKey: 'uniqueId',
      headerKey: 'header',
      data: [{
        columns: this.downloadReportHeader,
        rows: this.exportsData
      }]
    }
    
    downloadConfig.fileDetails = {
      title: "Action Trend - Open Actionables " + this.selectedTrendType.name,
      fileName: "Action Trend - Open Actionables " + this.selectedTrendType.name,
      accountName: this.accountDetails.display_name || this.accountDetails.name,
      brandName: this.brandDetails.display_name || this.brandDetails.name
    }

    if (downloadConfig.data.length) {
      this._analytics.prepareAndDownloadData(downloadConfig);
    }
  }

  onChartClick(data: any) {
    const dateObject = data.dateRange
    dateObject.isCustomDateRangeSelected = true
    this._helpers.setDatePicker(data.dateRange)
  }

  getExportsFields(trendType: string) {
    const fieldsToExport: any = [{
      header: "Date",
      dataKey: "time",
      type: "date",
      trend_type: trendType,
      defaultValue: "",
      order: "1",
      addInTooltip: false,
      showPercentage: false,
      format: ""
    }, {
      header: "Within TAT",
      dataKey: "within_tat",
      type: "number",
      order: "2",
      addInTooltip: true,
      showPercentage: true,
      totalKey: "total_count",
      defaultValue: 0,
      format: ""
    }, {
      header: "Missed TAT",
      dataKey: "outside_tat",
      addInTooltip: true,
      showPercentage: true,
      totalKey: "total_count",
      type: "number",
      order: "3",
      defaultValue: 0,
      display_format: ""
    }, {
      header: "Average Age(Hrs)",
      addInTooltip: true,
      showPercentage: false,
      dataKey: "age",
      order: "4",
      type: "number",
      defaultValue: 0,
      format: "round"
    }, {
      header: "Total",
      dataKey: "total_count",
      addInTooltip: true,
      showPercentage: false,
      totalKey: "total_count",
      type: "number",
      order: "7",
      defaultValue: 0,
      format: ""
    }]
    return fieldsToExport
  }
}
